import * as React from "react";
import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  Grid,
  Stack,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Phone as PhoneIcon,
  Star as StarIcon,
  Smartphone as SmartphoneIcon,
  Computer as ComputerIcon,
  Restaurant as RestaurantIcon,
  Inventory as InventoryIcon,
  Analytics as AnalyticsIcon,
  Security as SecurityIcon,
  Email as EmailIcon,
  Cloud as CloudIcon,
  Rocket as RocketIcon,
  Assessment as AssessmentIcon,
  PieChart as PieChartIcon,
  LocalDining as LocalDiningIcon,
  StoreMallDirectory as StoreMallDirectoryIcon,
  LocalCafe as LocalCafeIcon,
  Cake as CakeIcon,
  Icecream as IcecreamIcon,
  LunchDining as LunchDiningIcon
} from "@mui/icons-material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Navbar from '../../components/navbar.jsx';
import BillZappPlans from '../../components/billzappPlans.jsx';
import ContactModal from '../../components/contactModal.jsx';
import SiteFooter from '../../components/siteFooter.jsx';

const defaultTheme = createTheme();

export default function BillZappPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", type: "" });

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleContactModal = (type) => {
    setModalContent({
      title: type === 'demo' ? "Request Demo" : "Contact Us",
      type: type
    });
    setModalOpen(true);
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Navbar />
      
      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #00bcd4 100%)',
          color: 'white',
          py: { xs: 8, md: 2 },
          pt: { xs: 12, md: 15 }, // Add extra top padding to avoid navbar overlap
          textAlign: 'center'
        }}
      >
        <Container maxWidth="lg">
          {/* Home Button */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 3 }}>
            <Button
              variant="outlined"
              sx={{
                color: 'white',
                borderColor: 'white',
                '&:hover': {
                  borderColor: '#e1f5fe',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
              onClick={() => window.location.href = '/'}
            >
              ← Back to Home
            </Button>
          </Box>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2.5rem', md: '4rem' },
              fontWeight: 800,
              mb: 2,
              background: 'linear-gradient(45deg, #ffffff, #e1f5fe)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}
          >
            BillZapp
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: '1.2rem', md: '1.8rem' },
              mb: 3,
              opacity: 0.9
            }}
          >
            Complete Restaurant Management Solution for 
          </Typography>
          
          <Grid container spacing={{ xs: 1, md: 2 }} justifyContent="center" sx={{ maxWidth: '1000px', mx: 'auto', mb: 4 }}>
            <Grid item xs={4} sm={3} md={1.7}>
              <Box sx={{ 
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-5px)' },
                px: { xs: 0.5, md: 1 },
                py: 1
              }}>
                <RestaurantIcon sx={{ fontSize: { xs: 28, sm: 36, md: 40 }, mb: 1, opacity: 0.9 }} />
                <Typography variant="body2" sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.8rem' }, opacity: 0.8, lineHeight: 1.2 }}>
                  Restaurants
                </Typography>
              </Box>
            </Grid>
            
            <Grid item xs={4} sm={3} md={1.7}>
              <Box sx={{ 
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-5px)' },
                px: { xs: 0.5, md: 1 },
                py: 1
              }}>
                <StoreMallDirectoryIcon sx={{ fontSize: { xs: 28, sm: 36, md: 40 }, mb: 1, opacity: 0.9 }} />
                <Typography variant="body2" sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.8rem' }, opacity: 0.8, lineHeight: 1.2 }}>
                  Food Courts
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={4} sm={3} md={1.7}>
              <Box sx={{ 
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-5px)' },
                px: { xs: 0.5, md: 1 },
                py: 1
              }}>
                <LocalCafeIcon sx={{ fontSize: { xs: 28, sm: 36, md: 40 }, mb: 1, opacity: 0.9 }} />
                <Typography variant="body2" sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.8rem' }, opacity: 0.8, lineHeight: 1.2 }}>
                  Cafes
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={4} sm={3} md={1.7}>
              <Box sx={{ 
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-5px)' },
                px: { xs: 0.5, md: 1 },
                py: 1
              }}>
                <LocalDiningIcon sx={{ fontSize: { xs: 28, sm: 36, md: 40 }, mb: 1, opacity: 0.9 }} />
                <Typography variant="body2" sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.8rem' }, opacity: 0.8, lineHeight: 1.2 }}>
                  Fine Dining
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={4} sm={3} md={1.7}>
              <Box sx={{ 
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-5px)' },
                px: { xs: 0.5, md: 1 },
                py: 1
              }}>
                <LunchDiningIcon sx={{ fontSize: { xs: 28, sm: 36, md: 40 }, mb: 1, opacity: 0.9 }} />
                <Typography variant="body2" sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.8rem' }, opacity: 0.8, lineHeight: 1.2 }}>
                  QSR
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={4} sm={3} md={1.7}>
              <Box sx={{ 
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-5px)' },
                px: { xs: 0.5, md: 1 },
                py: 1
              }}>
                <CakeIcon sx={{ fontSize: { xs: 28, sm: 36, md: 40 }, mb: 1, opacity: 0.9 }} />
                <Typography variant="body2" sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.8rem' }, opacity: 0.8, lineHeight: 1.2 }}>
                  Bakeries
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={4} sm={3} md={1.7}>
              <Box sx={{ 
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-5px)' },
                px: { xs: 0.5, md: 1 },
                py: 1
              }}>
                <IcecreamIcon sx={{ fontSize: { xs: 28, sm: 36, md: 40 }, mb: 1, opacity: 0.9 }} />
                <Typography variant="body2" sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.8rem' }, opacity: 0.8, lineHeight: 1.2 }}>
                  Ice Cream Parlours
                </Typography>
              </Box>
            </Grid>
          </Grid>

          

        
          
        </Container>
      </Box>

      {/* Main Features Section */}
      <Box sx={{ py: { xs: 8, md: 12 }, position: 'relative', zIndex: 1 }}>
        <Container maxWidth="lg">
          <Box textAlign="center" sx={{ mb: 8 }}>
            <Typography variant="h2" fontWeight="bold" sx={{ mb: 3 }}>
              One Solution, Multiple Platforms
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '700px', mx: 'auto', mb: 6 }}>
              BillZapp works seamlessly across mobile and desktop platforms, giving you the flexibility 
              to manage your restaurant from anywhere, at any time.
            </Typography>
          </Box>

          <Grid container spacing={6} alignItems="center" sx={{ mb: 10 }}>
            {/* Screenshots Section */}
            <Grid item xs={12} md={6}>
              <Box sx={{ position: 'relative' }}>
                {/* Desktop Screenshot */}
                <Paper
                  elevation={12}
                  sx={{
                    borderRadius: '10px',
                    overflow: 'hidden',
                    mb: 4,
                    transform: 'rotate(-1deg)',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'rotate(0deg) scale(1.02)',
                    }
                  }}
                >
                  <Box
                    component="img"
                    sx={{
                      width: "100%",
                      height: "auto",
                      display: "block"
                    }}
                    src="/images/billzapp/desktop-dashboard.jpg"
                    alt="BillZapp Desktop Dashboard"
                    onError={(e) => {
                      e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAwIiBoZWlnaHQ9IjI4MCIgdmlld0JveD0iMCAwIDUwMCAyODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI1MDAiIGhlaWdodD0iMjgwIiBmaWxsPSIjZjVmNWY1Ii8+CjxyZWN0IHg9IjIwIiB5PSIyMCIgd2lkdGg9IjQ2MCIgaGVpZ2h0PSIyNDAiIGZpbGw9IiMxOTc2ZDIiLz4KPHN2ZyB4PSIyMzAiIHk9IjEyMCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB2aWV3Qm94PSIwIDAgNDAgNDAiIGZpbGw9IndoaXRlIj4KICA8cGF0aCBkPSJNMjAgMGMxMS4wNDYgMCAyMCA4Ljk1NCAyMCAyMHMtOC45NTQgMjAtMjAgMjBTMCA0MC4wNDYgMCAyMCAwIDguOTU0IDIwIDB6bTAgMzZjOC44MzcgMCAxNi03LjE2MyAxNi0xNlMzMS44MzcgNCAxNiA0UzQgMTEuMTYzIDQgMjBzNy4xNjMgMTYgMTYgMTZ6Ii8+CiAgPHBhdGggZD0iTTIyLjc1IDMwSDE3LjI1di02SDEzVjE1aDEzLjV2OS4zNzV6Ii8+Cjwvc3ZnPgo8dGV4dCB4PSIyNTAiIHk9IjE4MCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE2IiBmaWxsPSIjNjY2NjY2Ij5EZXNrdG9wIEFwcDwvdGV4dD4KPC9zdmc+Cg==";
                    }}
                  />
                </Paper>

                {/* Mobile Screenshots */}
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: { xs: 1, md: 2 },
                    mt: { xs: -2, md: -6 },
                    position: 'relative',
                    zIndex: 1
                  }}
                >
                  
                    <Paper
                      elevation={8}
                      sx={{
                        borderRadius: '10px',
                        overflow: 'hidden',
                        width: { xs: '100px', md: '120px' },
                        transform: 2 === 1 ? 'rotate(3deg)' : 'rotate(-3deg)',
                        transition: 'transform 0.3s ease',
                        '&:hover': {
                          transform: 'rotate(0deg) scale(1.05)',
                        }
                      }}
                    >
                      <Box
                        component="img"
                        sx={{
                          width: "100%",
                          height: { xs: "180px", md: "220px" },
                          objectFit: "cover"
                        }}
                        src={`/images/billzapp/mobile-menu.jpg`}
                        onError={(e) => {
                          e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjIyMCIgdmlld0JveD0iMCAwIDEyMCAyMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMjAiIGhlaWdodD0iMjIwIiBmaWxsPSIjZjVmNWY1Ii8+CjxjaXJjbGUgY3g9IjYwIiBjeT0iMTEwIiByPSIzMCIgZmlsbD0iIzE5NzZkMiIvPgo8dGV4dCB4PSI2MCIgeT0iMTYwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTIiIGZpbGw9IiM2NjY2NjYiPk1vYmlsZSBBcHA8L3RleHQ+Cjwvc3ZnPgo=";
                        }}
                      />
                    </Paper>
                    <Paper
                      elevation={8}
                      sx={{
                        borderRadius: '10px',
                        overflow: 'hidden',
                        width: { xs: '100px', md: '120px' },
                        transform: 1 === 1 ? 'rotate(3deg)' : 'rotate(-3deg)',
                        transition: 'transform 0.3s ease',
                        '&:hover': {
                          transform: 'rotate(0deg) scale(1.05)',
                        }
                      }}
                    >
                      <Box
                        component="img"
                        sx={{
                          width: "100%",
                          height: { xs: "180px", md: "220px" },
                          objectFit: "cover"
                        }}
                        src={`/images/billzapp/mobile-table.jpg`}
                        onError={(e) => {
                          e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjIyMCIgdmlld0JveD0iMCAwIDEyMCAyMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMjAiIGhlaWdodD0iMjIwIiBmaWxsPSIjZjVmNWY1Ii8+CjxjaXJjbGUgY3g9IjYwIiBjeT0iMTEwIiByPSIzMCIgZmlsbD0iIzE5NzZkMiIvPgo8dGV4dCB4PSI2MCIgeT0iMTYwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTIiIGZpbGw9IiM2NjY2NjYiPk1vYmlsZSBBcHA8L3RleHQ+Cjwvc3ZnPgo=";
                        }}
                      />
                    </Paper>
                
                </Box>
              </Box>
            </Grid>

            {/* Content Section */}
            <Grid item xs={12} md={6}>
              <Stack spacing={4}>
                {/* Mobile & Desktop Combined */}
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <SmartphoneIcon sx={{ fontSize: 32, color: 'primary.main', mr: 1 }} />
                    <ComputerIcon sx={{ fontSize: 32, color: 'primary.main', mr: 2 }} />
                    <Typography variant="h4" fontWeight="bold" color="primary">
                      Mobile & Desktop
                    </Typography>
                  </Box>
                  <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7, color: 'text.secondary' }}>
                    Experience the full power of restaurant management with BillZapp's unified platform. 
                    Start orders on mobile, complete them on desktop, and sync everything in real-time 
                    across all your devices.
                  </Typography>
                </Box>

                {/* Features Grid */}
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <RocketIcon sx={{ color: 'primary.main', mr: 1.5, fontSize: { xs: 20, md: 24 } }} />
                      <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        Quick Fast Billing
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <RestaurantIcon sx={{ color: 'primary.main', mr: 1.5, fontSize: { xs: 20, md: 24 } }} />
                      <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        Order Management
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <CloudIcon sx={{ color: 'primary.main', mr: 1.5, fontSize: { xs: 20, md: 24 } }} />
                      <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        Cloud Storage
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <InventoryIcon sx={{ color: 'primary.main', mr: 1.5, fontSize: { xs: 20, md: 24 } }} />
                      <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        Inventory Control
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <ComputerIcon sx={{ color: 'primary.main', mr: 1.5, fontSize: { xs: 20, md: 24 } }} />
                      <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        Multi Device / User Support
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <PieChartIcon sx={{ color: 'primary.main', mr: 1.5, fontSize: { xs: 20, md: 24 } }} />
                      <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        Real Time Analytics
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <SecurityIcon sx={{ color: 'primary.main', mr: 1.5, fontSize: { xs: 20, md: 24 } }} />
                      <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        Regional Language Support
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <AssessmentIcon sx={{ color: 'primary.main', mr: 1.5, fontSize: { xs: 20, md: 24 } }} />
                      <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        Reports
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <PhoneIcon sx={{ color: 'primary.main', mr: 1.5, fontSize: { xs: 20, md: 24 } }} />
                      <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        Customer Relationship Management
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>

                {/* Action Buttons */}
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 4 }}>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => handleContactModal('demo')}
                    sx={{ px: 4 }}
                  >
                    Request Demo
                  </Button>
                 
                </Stack>
              </Stack>
            </Grid>
          </Grid>

          {/* Key Benefits Section */}
          <Box sx={{ py: { xs: 4, md: 6 }, bgcolor: 'grey.50', borderRadius: 3, px: { xs: 2, md: 4 } }}>
            <Typography variant="h4" fontWeight="bold" textAlign="center" sx={{ mb: 4, fontSize: { xs: '1.5rem', md: '2rem' } }}>
              Why Choose BillZapp?
            </Typography>
            <Grid container spacing={4}>
              <Grid item xs={12} md={4}>
                <Box textAlign="center">
                  <SmartphoneIcon sx={{ fontSize: { xs: 40, md: 48 }, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                    Mobile Flexibility
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.85rem', md: '0.875rem' } }}>
                    Take orders and manage your restaurant on the go with our mobile app
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box textAlign="center">
                    <RocketIcon sx={{ fontSize: { xs: 40, md: 48 }, color: 'primary.main', mb: 2 }} />
                      <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                        Quick Fast Billing
                      </Typography>
                 
                  <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.85rem', md: '0.875rem' } }}>
                    Professional and speedy billing.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box textAlign="center">
                  <AnalyticsIcon sx={{ fontSize: { xs: 40, md: 48 }, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                    Unified Experience
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.85rem', md: '0.875rem' } }}>
                    Seamless sync between all platforms for a consistent experience
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>

      {/* Pricing Section */}
      <Box id="pricing" sx={{ py: { xs: 8, md: 12 }, bgcolor: 'grey.50', scrollMarginTop: '80px' }}>
        <Container maxWidth="lg">
          <Box textAlign="center" sx={{ mb: 5 }}>
            <Typography variant="h2" fontWeight="bold" sx={{ mb: 3 }}>
              Choose Your Plan
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '600px', mx: 'auto' }}>
              Start with our basic plan and upgrade as your business grows.
              Both plans include full customer support and regular updates.
              Pay monthly or yearly.
            </Typography>
          </Box>

          <BillZappPlans />

          <Box textAlign="center" sx={{ mt: 6 }}>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
              Need a custom solution? We also offer enterprise packages.
            </Typography>
            <Button
              variant="text"
              onClick={() => handleContactModal('contact')}
              sx={{ textDecoration: 'underline' }}
            >
              Contact us for enterprise pricing
            </Button>
          </Box>
        </Container>
      </Box>

      <ContactModal
        open={modalOpen}
        onClose={handleCloseModal}
        title={modalContent.title}
        message={modalContent.type === 'demo'
          ? 'Call us to schedule a free demo of BillZapp!'
          : 'Get in touch with our sales team for more information.'}
      />

      <SiteFooter />

    </ThemeProvider>
  );
}
